import React from 'react';
import { Link } from 'react-router-dom';
import useInstructions from './useInstructions';
import HtmlContent from '../HtmlContent';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const sectionMap = {
  'call-articles': { field: 'callForArticle', label: 'Call for Articles' },
  'types-of-articles': { field: 'typesOfArticle', label: 'Types of Articles' },
  'information-for-authors': { field: 'informationForAuthors', label: 'Information for Authors' },
  'submission-guidelines': { field: 'submissionGuidelines', label: 'Submission Guidelines' },
  'article-processing-charge': { field: 'articleProcessingCharge', label: 'Article Processing Charge (APC)' },
};

const GuidelinesContent = ({ submenuKey }) => {
  const { instructions, loading, error } = useInstructions();
  const section = sectionMap[submenuKey] || { field: submenuKey, label: submenuKey };

  // Get all section keys for navigation
  const sectionKeys = Object.keys(sectionMap);
  const currentIndex = sectionKeys.indexOf(submenuKey);
  const prevKey = currentIndex > 0 ? sectionKeys[currentIndex - 1] : null;
  const nextKey = currentIndex < sectionKeys.length - 1 ? sectionKeys[currentIndex + 1] : null;

  if (loading) {
    return (
      <div className="bg-white rounded-3xl p-12 text-center text-gray-500 shadow-sm animate-pulse">
        Loading instructions...
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white rounded-3xl p-8 text-center text-red-600 shadow-sm">
        {error}
      </div>
    );
  }

  const htmlContent = instructions && section?.field ? instructions[section.field] : null;

  return (
    <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-sm space-y-8">
      {/* Header */}
      <div>
        <span className="text-xs font-bold text-[#03478E] uppercase tracking-widest block mb-1">
          AUTHOR & SUBMISSION INFORMATION
        </span>
        <h1 className="page-title">
          {section.label}
        </h1>
        <p className="text-xs sm:text-sm text-gray-500 mt-1">
          AIM Journal of Homoeopathic Medicine (AJHM)
        </p>
      </div>

      {/* Content */}
      <div className="pt-2">
        {htmlContent ? (
          <HtmlContent
            content={htmlContent}
            className="prose prose-sm max-w-none text-gray-700 leading-relaxed font-sans space-y-4"
          />
        ) : (
          <div className="p-8 text-center bg-gray-50 rounded-2xl text-gray-500 text-sm">
            Content for this section is currently being updated by the editorial committee. Please check the Author Guidelines or contact the editorial office.
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      <div className="pt-6 border-t border-gray-100 flex items-center justify-between gap-4">
        {prevKey ? (
          <Link
            to={`/${prevKey}`}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-semibold rounded-full transition"
          >
            <FaArrowLeft className="text-[10px]" />
            <span>{sectionMap[prevKey].label}</span>
          </Link>
        ) : (
          <div />
        )}

        {nextKey ? (
          <Link
            to={`/${nextKey}`}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#03478E] hover:bg-[#023366] text-white hover:text-white text-xs font-semibold rounded-full transition shadow-xs"
          >
            <span>{sectionMap[nextKey].label}</span>
            <FaArrowRight className="text-[10px]" />
          </Link>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

export default GuidelinesContent;